import React from "react";
import "./styles.css";

export default function Footer() {
  return (
    <div className="footer">
      <p>
        {" "}
        <a
          href="https://github.com/jfelton101/weather-react"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Source Code
        </a>{" "}
        by Jordan Felton
      </p>
    </div>
  );
}
